<template>
  <div>
    <div v-if="isCollapse">
      <el-link type="primary" :icon="showIcon" @click="showMenu"></el-link>
      <el-link  style="margin-left: 30px"  type="primary" @click="onClose" >退出</el-link>
    </div>
    <el-container style="width: 880px;margin: 0 auto;" >
      <el-aside style="width: 110px;margin-top: 10px;" v-if="isShow">
        <el-menu router
                 :default-active="leftActiveIndex"
                 class="el-menu-vertical-demo">
          
          <el-menu-item v-for="item in leftMenus" :index="item.index" :key="item.index" :route="item.path"
          >
            <span slot="title">{{item.name}}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view>
        </router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  export default {
    name: 'leftMain',
    data(){
      return{
        leftMenus:[],
        leftActiveIndex: '2-1',
        leftMenu:'/price',
        isCollapse:false,
        isShow:true,
        showIcon:'el-icon-s-unfold'
      }
    },
    methods: {
      initLoading(){
        let scren_width=window.screen.width
        let scren_height=window.screen.height
        if(scren_width<600){
          this.isCollapse=true
          this.isShow=false
        }
      
      },
      getMenu(){
        let that=this
        let menus=[]
        let user = this.$store.getters['user']
         menus=localStorage.getItem('menu_'+user.accountNo)
        if(menus!=null){
          menus=JSON.parse(menus)
        }else{
          menus=that.$store.getters['defaultMenu']
        }
        let def=menus.filter(item=>{
          if(item.isCheck){
            return item
          }
        })
        def=this._.orderBy(def,['level'],['asc'])
        console.log(def)
        this.leftMenus=def
        this.leftActiveIndex=this.leftMenus[0].index
      },
      showMenu(){
        this.isShow=!this.isShow
        if(this.isShow){
          this.showIcon='el-icon-s-fold'
        }else{
          this.showIcon='el-icon-s-unfold'
        }
      },
      onClose () {
        this.$store.commit('WEB_DB', null)
        this.$store.commit('SET_SESSIONS', [])
        this.$store.commit('SET_SESSION', {})
        localStorage.removeItem('token')
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('activeIndex')
        this.$router.push({ name: 'login' })
        this.$store.dispatch('socketClose')
      },
    },
    mounted(){
      this.getMenu()
      this.initLoading()
    },
  }
</script>

<style scoped>
  /deep/ .el-menu-item{
    padding: 0 5px !important;
  }
</style>
